export default "__VITE_ASSET__81e53a7a__"